
export default {
    namespaced: true,
    state: {
        is_toolbar_visible: false,
        page_loader: false,
        search: "",
        isPublicToken: false
        
    },
    actions: {
        setSearch({commit}, value){
            commit('SEARCH', value)
        }
    },
    mutations: {
        IS_TOOLBAR_VISIBLE: (state, value) => state.is_toolbar_visible = value,
        PAGE_LOADER: (state, value) => state.page_loader = value,
        SEARCH: (state, value) => state.search = value,
        setPublicSession(state, token){
          state.isPublicToken = true
        }
    },
    getters: {
        isToolBarVisible: (state) => state.is_toolbar_visible,        
        pageLoader: (state) => state.page_loader,     
        search: (state) => state.search,
        isPublicToken: (state) => state.isPublicToken
    }
}